import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import Green from "../../../styles/svg/compliance-green.svg";

function ThankYou({ message = "Email has been sent successfully!", open, handleClose }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="thank-you-dialog"
    >
      <DialogContent className="dialog-content">
        <img src={Green} alt="Green" width={"40px"} height={"40px"}/>
        <Typography variant="h6">Success</Typography>
        <Typography variant="body1" color="textSecondary" align="center">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button
          onClick={handleClose}
          variant="contained"
          color="primary"
          className="ok-button"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ThankYou;